export function getdata() {
	var obj = {
		searchlist: [{
				prop: "bianh",
				label: '编号',
				type: "input"
			},
			{
				prop: "hansje",
				label: '含税金额',
				type: "inputplus"
			},
			{
				prop: "shuie",
				label: '税额',
				type: "inputplus"
			},
		],
		searchdata: {},
		headData: [{
				title: "编号",
				prop: "bianh",
			},
			{
				title: "收入日期",
				prop: "shourrq",
			},
			{
				title: "税额",
				prop: "shuie",
			},
			{
				title: "含税金额",
				prop: "hansje",
			},
			{
				title: "购买方名称",
				prop: "goufmc",
				width: 200
			},
			{
				title: "购买方纳税人识别号",
				prop: "goufsbh",
				width: 200
			},
			{
				title: "购买方地址、电话",
				prop: "goufdzdh",
				width: 200
			},
			{
				title: "购买方开户行及账号",
				prop: "goufkhh",
				width: 200
			},
			{
				title: "销售方名称",
				prop: "xiaofmc",
				width: 200
			},
			{
				title: "销售方纳税人识别号",
				prop: "xiaofsbh",
				width: 200
			},
			{
				title: "销售方地址、电话",
				prop: "xiaofdzdh",
				width: 200
			},
			{
				title: "销售方开户行及账号",
				prop: "xiaofkhh",
				width: 200
			},
			{
				title: "备注",
				prop: "beiz",
				width: 200
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},

		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		tableJson: "{\n" +
			"  \"searchList\":[\n" +
			"    {\n" +
			"      \"name\":\"编号\",\n" +
			"      \"column\":\"bianh\",\n" +
			"      \"originName\":\"编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"税款所属期\",\n" +
			"      \"column\":\"suosq\",\n" +
			"      \"originName\":\"税款所属期\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"收入日期\",\n" +
			"      \"column\":\"shourrq\",\n" +
			"      \"originName\":\"收入日期\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"税额\",\n" +
			"      \"column\":\"shuie\",\n" +
			"      \"originName\":\"税额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"含税金额\",\n" +
			"      \"column\":\"hansje\",\n" +
			"      \"originName\":\"含税金额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方名称\",\n" +
			"      \"column\":\"goufmc\",\n" +
			"      \"originName\":\"购买方名称\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方纳税人识别号\",\n" +
			"      \"column\":\"goufsbh\",\n" +
			"      \"originName\":\"购买方纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方地址、电话\",\n" +
			"      \"column\":\"goufdzdh\",\n" +
			"      \"originName\":\"购买方地址、电话\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方开户行及账号\",\n" +
			"      \"column\":\"goufkhh\",\n" +
			"      \"originName\":\"购买方开户行及账号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方名称\",\n" +
			"      \"column\":\"xiaofmc\",\n" +
			"      \"originName\":\"销售方名称\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方纳税人识别号\",\n" +
			"      \"column\":\"xiaofsbh\",\n" +
			"      \"originName\":\"销售方纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方地址、电话\",\n" +
			"      \"column\":\"xiaofdzdh\",\n" +
			"      \"originName\":\"销售方地址、电话\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方开户行及账号\",\n" +
			"      \"column\":\"xiaofkhh\",\n" +
			"      \"originName\":\"销售方开户行及账号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"备注\",\n" +
			"      \"column\":\"beiz\",\n" +
			"      \"originName\":\"备注\",\n" +
			"      \"show\":\"0\"\n" +
			"    }\n" +
			"  ],\n" +
			"  \"headData\":[\n" +
			"    {\n" +
			"      \"name\":\"编号\",\n" +
			"      \"column\":\"bianh\",\n" +
			"      \"originName\":\"编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"收入日期\",\n" +
			"      \"column\":\"shourrq\",\n" +
			"      \"originName\":\"收入日期\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"税额\",\n" +
			"      \"column\":\"shuie\",\n" +
			"      \"originName\":\"税额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"含税金额\",\n" +
			"      \"column\":\"hansje\",\n" +
			"      \"originName\":\"含税金额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方名称\",\n" +
			"      \"column\":\"goufmc\",\n" +
			"      \"originName\":\"购买方名称\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方纳税人识别号\",\n" +
			"      \"column\":\"goufsbh\",\n" +
			"      \"originName\":\"购买方纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方地址、电话\",\n" +
			"      \"column\":\"goufdzdh\",\n" +
			"      \"originName\":\"购买方地址、电话\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方开户行及账号\",\n" +
			"      \"column\":\"goufkhh\",\n" +
			"      \"originName\":\"购买方开户行及账号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方名称\",\n" +
			"      \"column\":\"xiaofmc\",\n" +
			"      \"originName\":\"销售方名称\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方纳税人识别号\",\n" +
			"      \"column\":\"xiaofsbh\",\n" +
			"      \"originName\":\"销售方纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方地址、电话\",\n" +
			"      \"column\":\"xiaofdzdh\",\n" +
			"      \"originName\":\"销售方地址、电话\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方开户行及账号\",\n" +
			"      \"column\":\"xiaofkhh\",\n" +
			"      \"originName\":\"销售方开户行及账号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"备注\",\n" +
			"      \"column\":\"beiz\",\n" +
			"      \"originName\":\"备注\",\n" +
			"      \"show\":\"0\"\n" +
			"    }\n" +
			"  ],\n" +
			"  \"formlist\":[\n" +
			"       {\n" +
			"      \"name\":\"编号\",\n" +
			"      \"column\":\"bianh\",\n" +
			"      \"originName\":\"编号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"税款所属期\",\n" +
			"      \"column\":\"suosq\",\n" +
			"      \"originName\":\"税款所属期\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"收入日期\",\n" +
			"      \"column\":\"shourrq\",\n" +
			"      \"originName\":\"收入日期\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"税额\",\n" +
			"      \"column\":\"shuie\",\n" +
			"      \"originName\":\"税额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"含税金额\",\n" +
			"      \"column\":\"hansje\",\n" +
			"      \"originName\":\"含税金额\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方名称\",\n" +
			"      \"column\":\"goufmc\",\n" +
			"      \"originName\":\"购买方名称\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方纳税人识别号\",\n" +
			"      \"column\":\"goufsbh\",\n" +
			"      \"originName\":\"购买方纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方地址、电话\",\n" +
			"      \"column\":\"goufdzdh\",\n" +
			"      \"originName\":\"购买方地址、电话\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"购买方开户行及账号\",\n" +
			"      \"column\":\"goufkhh\",\n" +
			"      \"originName\":\"购买方开户行及账号\",\n" +
			"      \"show\":\"1\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方名称\",\n" +
			"      \"column\":\"xiaofmc\",\n" +
			"      \"originName\":\"销售方名称\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方纳税人识别号\",\n" +
			"      \"column\":\"xiaofsbh\",\n" +
			"      \"originName\":\"销售方纳税人识别号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方地址、电话\",\n" +
			"      \"column\":\"xiaofdzdh\",\n" +
			"      \"originName\":\"销售方地址、电话\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"销售方开户行及账号\",\n" +
			"      \"column\":\"xiaofkhh\",\n" +
			"      \"originName\":\"销售方开户行及账号\",\n" +
			"      \"show\":\"0\"\n" +
			"    },\n" +
			"    {\n" +
			"      \"name\":\"备注\",\n" +
			"      \"column\":\"beiz\",\n" +
			"      \"originName\":\"备注\",\n" +
			"      \"show\":\"0\"\n" +
			"    }\n" +
			"  ]\n" +
			"}"
	}
	return obj
}
